import { ROOT_MENU_ENUM } from './menus.enum';
import { IMenu } from '@dfl/mui-react-common';
import { DeliveryIcon, OfferIcon, OrderIcon, OrderIssuesIcon } from 'modules/sales/common/components/icons';
import { ClientIcon } from 'modules/crm/common/components/icons';
import ProductIcon from 'modules/inventory/common/components/Icons/ProductIcon';
import {
  AnalyticsOutlined,
  AssessmentOutlined,
  CancelOutlined,
  HubOutlined,
  InsightsOutlined,
  Inventory2Outlined,
  LocationOnOutlined,
  PaymentsOutlined,
  StorefrontOutlined,
  SupportAgentOutlined,
  SyncAlt,
  TipsAndUpdatesOutlined,
} from '@mui/icons-material';
import { REPORTS_PERMISSIONS } from 'modules/dashboard/constant/reports.permissions';
import { SeoAuditIcon } from 'components/icons/SeoAuditIcon';
import {
  disableCancelledOrdersReport,
  disabledSalesDeliveriesReport,
  disabledSalesIncidencesReport,
  disabledSalesIncidenceResolutionsReport,
  disabledInventoryPerformanceProductsReport,
  disabledInventoryLogisticsLocationReport,
  disabledCmsSeoAuditReport,
  disabledClientLocationReport,
  disabledCompletedSubordersReport,
  disabledCustomerActions,
  disabledInventoryAssortmentGapReport,
  disabledInventoryRegionalReport,
  disabledProviderEvaluationReport,
} from 'utils/flags-utils';

type ROOT_MENU_WITHOUT_REPORTS = Exclude<ROOT_MENU_ENUM, ROOT_MENU_ENUM.REPORTS | ROOT_MENU_ENUM.HOME>;

export const SECTION_REPORTS_MENU: Record<ROOT_MENU_WITHOUT_REPORTS, IMenu[]> = {
  [ROOT_MENU_ENUM.SALES]: [
    {
      title: 'main_menu.admin.section.general.reports',
      prefix: '/reports/sales',
      atLessOne: true,
      items: [
        {
          title: 'main_menu.admin.section.reports.paid-orders',
          path: '/reports/sales/orders',
          partialMatch: true,
          icon: <OrderIcon fontSize='small' />,
          permissions: [REPORTS_PERMISSIONS.REPORT_ORDERS_PAID],
        },
        ...(!disabledSalesDeliveriesReport
          ? [
              {
                title: 'main_menu.admin.section.reports.suborders',
                path: '/reports/sales/deliveries',
                partialMatch: true,
                icon: <DeliveryIcon fontSize='small' />,
                permissions: [REPORTS_PERMISSIONS.REPORT_SALES],
              },
            ]
          : []),
        {
          title: 'main_menu.admin.section.reports.product-profitability',
          path: '/reports/sales/product-profitability',
          partialMatch: true,
          icon: <InsightsOutlined fontSize='small' />,
          permissions: [REPORTS_PERMISSIONS.REPORT_INVENTORY_FLOWS],
        },
        {
          title: 'main_menu.admin.section.sales.offers',
          path: '/reports/sales/offers',
          partialMatch: true,
          icon: <OfferIcon fontSize='small' />,
          permissions: [REPORTS_PERMISSIONS.REPORT_OFFERS],
        },
        ...(!disabledSalesIncidencesReport
          ? [
              {
                title: 'main_menu.admin.section.sales.issues',
                path: '/reports/sales/incidences',
                partialMatch: true,
                icon: <OrderIssuesIcon fontSize='small' />,
                permissions: [REPORTS_PERMISSIONS.REPORT_INCIDENCES],
              },
            ]
          : []),
        ...(!disabledSalesIncidenceResolutionsReport
          ? [
              {
                title: 'main_menu.admin.section.sales.incidence-resolutions',
                path: '/reports/sales/incidence-resolutions',
                partialMatch: true,
                icon: <TipsAndUpdatesOutlined fontSize='small' />,
              },
            ]
          : []),
        ...(!disableCancelledOrdersReport
          ? [
              {
                title: 'main_menu.admin.section.sales.cancelled-orders',
                path: '/reports/sales/cancelled-orders',
                partialMatch: true,
                icon: <CancelOutlined fontSize='small' />,
                permissions: [REPORTS_PERMISSIONS.REPORT_CANCELLED_ORDERS_READ],
              },
            ]
          : []),
      ],
    },
  ],
  [ROOT_MENU_ENUM.INVENTORY]: [
    {
      title: 'main_menu.admin.section.reports.title',
      prefix: '/reports/inventory',
      atLessOne: true,
      items: [
        {
          title: 'main_menu.admin.section.inventory.products',
          path: '/reports/inventory/products',
          partialMatch: true,
          icon: <ProductIcon fontSize='small' />,
          permissions: [REPORTS_PERMISSIONS.REPORT_PRODUCT],
        },
        {
          title: 'main_menu.admin.section.inventory.inventoryCoverage',
          path: '/reports/inventory/coverage',
          partialMatch: true,
          icon: <Inventory2Outlined fontSize='small' />,
          permissions: [REPORTS_PERMISSIONS.REPORT_INVENTORY_COVERAGE],
        },
        ...(!disabledInventoryRegionalReport
          ? [
              {
                title: 'main_menu.admin.section.inventory.operation',
                path: '/reports/inventory/regional-coverage',
                partialMatch: false,
                icon: <AssessmentOutlined fontSize='small' />,
                permissions: [REPORTS_PERMISSIONS.REPORT_INVENTORY_OPERATION],
              },
            ]
          : []),
        ...(!disabledInventoryAssortmentGapReport
          ? [
              {
                title: 'main_menu.admin.section.inventory.gapSurtido',
                path: '/reports/inventory/regional-coverage/gaps',
                partialMatch: true,
                icon: <SyncAlt fontSize='small' />,
                permissions: [REPORTS_PERMISSIONS.REPORT_INVENTORY_REGIONAL_COVERAGE],
              },
            ]
          : []),
        // {
        //   title: 'main_menu.admin.section.inventory.inventoryRisk',
        //   path: '/reports/inventory/risk-replenishment',
        //   partialMatch: true,
        //   icon: <AutorenewOutlined fontSize='small' />,
        //   permissions: [REPORTS_PERMISSIONS.REPORT_INVENTORY_RISK],
        // },
        ...(!disabledInventoryPerformanceProductsReport
          ? [
              {
                title: 'main_menu.admin.section.inventory.productsPerformance',
                path: '/reports/inventory/performance-products',
                partialMatch: false,
                icon: <InsightsOutlined fontSize='small' />,
                permissions: [REPORTS_PERMISSIONS.REPORT_PRODUCT_SCORE],
              },
            ]
          : []),
        ...(!disabledInventoryLogisticsLocationReport
          ? [
              {
                title: 'main_menu.admin.section.reports.logistics-location',
                path: '/reports/inventory/logistics-location',
                partialMatch: true,
                icon: <LocationOnOutlined fontSize='small' />,
                permissions: [REPORTS_PERMISSIONS.REPORT_LOGISTIC_LOCATION],
              },
            ]
          : []),
        ...(!disabledProviderEvaluationReport
          ? [
              {
                title: 'main_menu.admin.section.inventory.providerEvaluation',
                path: '/reports/providers/providers',
                partialMatch: true,
                icon: <StorefrontOutlined fontSize='small' />,
                permissions: [REPORTS_PERMISSIONS.REPORT_PROVIDER_EVALUATION],
              },
            ]
          : []),
        // {
        //   title: 'main_menu.admin.section.inventory.warehouses',
        //   path: '/reports/inventory/warehouses',
        //   partialMatch: true,
        //   icon: <WarehouseIcon fontSize='small' />,
        //   disabled: true
        // },
        // {
        //   title: 'main_menu.admin.section.inventory.distribution-centers',
        //   path: '/reports/inventory/distribution-centers',
        //   partialMatch: true,
        //   icon: <DistributionCenterIcon fontSize='small' />,
        //   disabled: true
        // },
        // {
        //   title: 'category:list',
        //   path: '/reports/inventory/settings/categories',
        //   partialMatch: true,
        //   icon: <CategoryIcon fontSize='small' />,
        //   disabled: true
        // },
      ],
    },
  ],
  [ROOT_MENU_ENUM.CRM]: [
    {
      title: 'main_menu.admin.section.general.reports',
      prefix: 'reports/crm',
      atLessOne: true,
      items: [
        {
          title: 'main_menu.admin.section.clients.clients',
          path: '/reports/crm/clients',
          partialMatch: true,
          icon: <ClientIcon fontSize='small' />,
          permissions: [REPORTS_PERMISSIONS.REPORT_CLIENTS],
        },
        ...(!disabledCompletedSubordersReport
          ? [
              {
                title: 'main_menu.admin.section.clients.customerCare',
                path: '/reports/crm/customer-care',
                partialMatch: true,
                icon: <OrderIcon fontSize='small' />,
                permissions: [REPORTS_PERMISSIONS.REPORT_CLIENTS],
              },
            ]
          : []),
        ...(!disabledCustomerActions
          ? [
              {
                title: 'main_menu.admin.section.clients.customerCareActions',
                path: '/reports/crm/customer-actions',
                partialMatch: true,
                icon: <SupportAgentOutlined fontSize='small' />,
                permissions: [REPORTS_PERMISSIONS.REPORT_CLIENTS],
              },
            ]
          : []),
        ...(!disabledClientLocationReport
          ? [
              {
                title: 'main_menu.admin.section.clients.clientsLocation',
                path: '/reports/crm/location-clients',
                partialMatch: true,
                icon: <AssessmentOutlined fontSize='small' />,
                permissions: [REPORTS_PERMISSIONS.REPORT_CLIENTS],
              },
            ]
          : []),
      ],
    },
  ],
  [ROOT_MENU_ENUM.CMS]: [
    {
      title: 'main_menu.admin.section.general.reports',
      prefix: '/cms',
      atLessOne: true,
      items: [
        ...(!disabledCmsSeoAuditReport
          ? [
              {
                title: 'main_menu.admin.section.cms.seo-audit',
                path: '/reports/cms/seo-audit',
                partialMatch: true,
                icon: <SeoAuditIcon fontSize='small' />,
                permissions: [REPORTS_PERMISSIONS.REPORT_SEO_AUDIT],
              },
            ]
          : []),
        {
          title: 'main_menu.admin.section.cms.integration-dashboard',
          path: '/reports/integrations/dashboard',
          partialMatch: true,
          icon: <HubOutlined fontSize='small' />,
          permissions: [REPORTS_PERMISSIONS.INTEGRATION_DASHBOARD_READ],
        },
      ],
    },
  ],
  [ROOT_MENU_ENUM.SECURITY]: [],
  [ROOT_MENU_ENUM.SETTINGS]: [
    {
      title: 'main_menu.admin.section.reports.payments',
      prefix: '/reports/sales',
      atLessOne: true,
      items: [
        {
          title: 'main_menu.admin.section.sales.business',
          path: '/reports/sales/business',
          partialMatch: true,
          icon: <PaymentsOutlined fontSize='small' />,
          permissions: [REPORTS_PERMISSIONS.PAYMENT_BIZ_REPORT_READ],
        },
        {
          title: 'main_menu.admin.section.sales.ops',
          path: '/reports/sales/operations',
          partialMatch: true,
          icon: <AnalyticsOutlined fontSize='small' />,
          permissions: [REPORTS_PERMISSIONS.PAYMENT_OPS_REPORT_READ],
        },
        {
          title: 'main_menu.admin.section.sales.payment-logs',
          path: '/reports/sales/payment-logs',
          partialMatch: true,
          icon: <AssessmentOutlined fontSize='small' />,
        },
      ],
    },
  ],
  [ROOT_MENU_ENUM.CONCILIATION]: [],
};
